var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubtract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97011 3.03006L8.50002 2.50015C9.0523 1.94787 9.0523 1.05244 8.50002 0.500151C7.94773 -0.0521341 7.0523 -0.0521333 6.50002 0.500151L5.95753 1.04264C6.4188 1.88329 7.11726 2.57611 7.97011 3.03006ZM4.50209 2.49807L1.8564 5.14377C1.43134 5.56883 1.21881 5.78136 1.07907 6.04246C0.939336 6.30356 0.88039 6.59828 0.7625 7.18773L0.647104 7.76472C0.580582 8.09733 0.547321 8.26363 0.641929 8.35824C0.736537 8.45285 0.902842 8.41959 1.23545 8.35306L1.81243 8.23767L1.81244 8.23766C2.40189 8.11978 2.69661 8.06083 2.95771 7.9211C3.2188 7.78137 3.43132 7.56884 3.85636 7.14381L3.85638 7.14379L3.8564 7.14377L6.51082 4.48935C5.71004 3.96919 5.02669 3.29029 4.50209 2.49807Z",
    fill: "#3DB2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.f3e93c08dac9b32f29949abb7d87da03.svg";
export { ForwardRef as ReactComponent };